<div id="unauthorized-dialog" class="unauthorized container-fluid">
    <div class="modal-header justify-content-center">
        <img src="https://downloads.rouseservices.com/auth0/images/rse_analytics.svg"/>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="unauthorized-content">
                <h2 class="unauthorized-title">
                    {{ 'main.core.auth.unauthorized' | translate }}
                </h2>
                <p class="unauthorized-text">
                    {{ 'main.core.auth.you_are_not_authorized' | translate }}
                    {{ 'main.core.auth.sign_with_other_account' | translate }}
                </p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="modal-footer pull-right">
                <button id="UnauthorizedCancelButton" class="unauthorized-button" (click)="closeClick()">
                    <i class="fa fa-times"></i>&nbsp;&nbsp;&nbsp;{{ 'main.core.auth.back_to_sign_in' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
